import styled from '@emotion/styled';
import { Grid, withStyles } from '@material-ui/core';
import { Tooltip } from "../../../tooltip";
import { Magnetic as Mi } from "../../../../styles";
export const StyledAttribute = styled(Grid) `
	margin-bottom: ${Mi.spacer12};
	width: 100%;
`;
export const StyledTooltip = withStyles(() => ({
    tooltip: {
        fontSize: Mi.labelValuePairLabelFontSize
    },
    arrow: {
        fontSize: Mi.fontSize12
    }
}))(Tooltip);
//# sourceMappingURL=VehicleAttribute.style.js.map